<template>
	<el-dialog v-dialogDrag title="添加好友" :visible.sync="dialogVisible" width="400px" :before-close="onClose" :modal="false"
		custom-class="add-friend">
		<el-input placeholder="输入用户名或昵称按下enter搜索，最多展示20条" class="input-with-select" v-model="searchText" size="small"
			@keyup.enter.native="onSearch()">
			<i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch()"> </i>
		</el-input>
		<el-scrollbar style="height:400px">
			<div v-for="(user) in users" :key="user.id" v-show="user.id != userStore.userInfo.id">
				<div class="item">
					<div class="avatar">
						<head-image :name="user.nickName" :url="user.headImage" :online="user.online"></head-image>
					</div>
					<div class="friend-info">
						<div class="nick-name">
							<div>{{ user.nickName }}</div>
							<div :class="user.online ? 'online-status  online' : 'online-status'">{{
								user.online ? "[在线]" : "[离线]" }}</div>
						</div>
						<div class="user-name">
							<div>用户名:{{ user.userName }}</div>
						</div>
					</div>
					<el-button type="primary" size="mini" v-show="canAdd(user)"
						@click="onAddFriend(user)">添加</el-button>
					<el-button type="info" size="mini" v-show="isFriend(user.id)" plain disabled>已添加</el-button>
					<el-button type="info" size="mini" v-show="isPendingSent(user)" plain disabled>等待验证</el-button>
					<el-button type="primary" size="mini" v-show="isPendingReceived(user)"
						@click="onOpenRequests">去处理</el-button>
				</div>
			</div>
		</el-scrollbar>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue'


export default {
	name: "addFriend",
	components: { HeadImage },
	data() {
		return {
			users: [],
			searchText: ""
		}
	},
	props: {
		dialogVisible: {
			type: Boolean
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		onSearch() {
			if (!this.searchText) {
				this.users = [];
				return;
			}
			this.$http({
				url: "/user/search",
				method: "get",
				params: {
					name: this.searchText
				}
			}).then((data) => {
				this.users = data;
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/request",
				method: "post",
				data: {
					receiverId: user.id,
					verifyMessage: "请求添加你为好友"
				}
			}).then(() => {
				this.$message.success("好友申请已发送，等待对方接受");
				this.$set(user, "relationStatus", "PENDING_SENT");
				this.$nextTick(() => this.$forceUpdate());
			})
		},
		canAdd(user) {
			return !this.isFriend(user.id) && !this.isPendingSent(user) && !this.isPendingReceived(user);
		},
		isPendingSent(user) {
			return user.relationStatus == "PENDING_SENT";
		},
		isPendingReceived(user) {
			return user.relationStatus == "PENDING_RECEIVED";
		},
		onOpenRequests() {
			this.$emit("open-requests");
		},
		isFriend(userId) {
			return this.friendStore.isFriend(userId);
		}
	}
}
</script>

<style lang="scss">
.add-friend {
	.item {
		height: 65px;
		display: flex;
		position: relative;
		padding-left: 15px;
		align-items: center;
		padding-right: 25px;
		color: var(--im-tech-text);
		border-radius: 8px;
		transition: background 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			background: rgba(43, 223, 255, 0.1);
			box-shadow: inset 3px 0 0 rgba(43, 223, 255, 0.7);
		}

		.friend-info {
			margin-left: 15px;
			flex: 3;
			display: flex;
			flex-direction: column;
			flex-shrink: 0;
			overflow: hidden;

			.nick-name {
				display: flex;
				flex-direction: row;
				font-weight: 600;
				font-size: 16px;
				line-height: 25px;
				color: var(--im-tech-text);

				.online-status {
					font-size: 12px;
					font-weight: 600;
					color: var(--im-tech-text-muted);

					&.online {
						color: var(--im-tech-success, #37f07b);
					}
				}
			}

			.user-name {
				display: flex;
				flex-direction: row;
				font-size: 12px;
				line-height: 20px;
				color: var(--im-tech-text-muted);
			}

		}
	}
}
</style>
